import Cookies from "js-cookie";

const valueSeparator = "&";

export default class Status {
    constructor(cookieName, domain, eventDispatcher, acceptCallback = () => {}, declineCallback = () => {}) {
        this.cookieName = cookieName;
        this.domain = domain;
        this.eventDispatcher = eventDispatcher;
        this.acceptCallback = acceptCallback;
        this.declineCallback = declineCallback;
    }

    get consentCookie() {
        return Cookies.get(this.cookieName);
    }

    hasSelected() {
        return typeof this.consentCookie !== "undefined";
    }

    acceptedTypes() {
        if (!this.hasSelected()) return [];
        return this.consentCookie.split(valueSeparator);
    }

    accept(categoryName) {
        if (this.isAccepted(categoryName)) {
            return;
        }

        const acceptedTypes = this.acceptedTypes();
        acceptedTypes.push(categoryName);
        this.setCookie(acceptedTypes);

        this.eventDispatcher.acceptCategory(categoryName);
        this.acceptCallback(categoryName);
    }

    isAccepted(categoryName) {
        const acceptedTypes = this.acceptedTypes();
        return acceptedTypes.some(x => x === categoryName);
    }

    decline(categoryName) {
        // It does not make sense to decline what has not been accepted
        if (!this.isAccepted(categoryName)) {
            return;
        }

        const acceptedTypes = this.acceptedTypes();
        const updatedTypes = acceptedTypes.filter(x => x !== categoryName);
        this.setCookie(updatedTypes);

        this.eventDispatcher.declineCategory(categoryName);
        this.declineCallback(categoryName);
    }

    setCookie(acceptedCategories) {
        const value = acceptedCategories.join(valueSeparator);
        Cookies.set(this.cookieName, value, { expires: 365, domain: this.domain, secure: true });
    }

    pageLoad() {
        const acceptedTypes = this.acceptedTypes();
        acceptedTypes.forEach(categoryName => this.eventDispatcher.acceptCategory(categoryName));
    }
}
